import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=4c5f0af9&scoped=true"
import script from "./schedule.vue?vue&type=script&lang=js"
export * from "./schedule.vue?vue&type=script&lang=js"
import style0 from "./schedule.vue?vue&type=style&index=0&id=4c5f0af9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5f0af9",
  null
  
)

export default component.exports